/**
 * API base URL — use when CRA proxy is unavailable (e.g. direct open on :9010).
 * Set REACT_APP_API_URL=http://localhost:9000 in frontend/.env
 */
import axios from 'axios';

export const API_BASE = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');

export function apiPath(path) {
  const p = path.startsWith('/') ? path : `/${path}`;
  return API_BASE ? `${API_BASE}${p}` : p;
}

if (API_BASE) {
  axios.defaults.baseURL = API_BASE;
}
